// Casca raiz do app: aplica a classe .ueb-portal (ativa os tokens de tema),
// o ThemeProvider e monta o toast global. Envolve todas as rotas via Outlet.
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from './theme/ThemeContext';
import NotifyComp from './components/Notify';
import './theme/tokens.css';
import './theme/ui.css';
import './theme/layout.css';

export default function AppLayout() {
    return (
        <ThemeProvider>
            <div className="ueb-portal">
                <NotifyComp />
                <Outlet />
            </div>
        </ThemeProvider>
    );
}
